import PassportStudentInfoReviewer from "./PassportStudentInfoReviewer";

export default PassportStudentInfoReviewer;